export default "__VITE_ASSET__CC20W34j__";